<template>
  <div class="body">
    <headerComponent :callback="headerCallbackHandler" />
    <main>
      <div class="wrapper-challenges">
        <div class="menu-column">
          <router-link
            to="/challenges/inter_group"
            tag="div"
            class="menu-item"
            active-class="selected"
            ><p>
              {{ td("views.challenges.challenges.inter_groups") }}
            </p></router-link
          >
          <router-link
            to="/challenges/inter_team"
            tag="div"
            class="menu-item"
            active-class="selected"
            ><p>
              {{ td("views.challenges.challenges.inter_teams") }}
            </p></router-link
          >
          <router-link
            to="/challenges/inside_team"
            tag="div"
            class="menu-item"
            active-class="selected"
            ><p>
              {{ td("views.challenges.challenges.inside_team") }}
            </p></router-link
          >
          <router-link
            to="/challenges/by_function"
            tag="div"
            class="menu-item"
            active-class="selected"
            ><p>
              {{ td("views.challenges.challenges.by_function") }}
            </p></router-link
          >
          <router-link
            to="/challenges/closed"
            tag="div"
            class="menu-item"
            active-class="selected"
            ><p v-html="td('views.challenges.challenges.closed_challenges')"></p
          ></router-link>
        </div>
        <router-view />

        <transition name="fade">
          <div class="container-alert" v-if="show_alert_box === true">
            <alertBox
              :msg="msg_alert"
              :callback="alertCallback"
              :delay="3000"
            />
          </div>
        </transition>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import headerComponent from "./../../components/header/headerComponent";
import { td } from "../../traductions/traductionsHelpers";

export default {
  name: "Challenges",
  components: {
    headerComponent
  },
  data: () => {
    return {
      td,
      show_alert_box: false,
      admin_levels: {},
      user: {},
      admin_level: "",
      circle: {}
    };
  },
  methods: {
    headerCallbackHandler(obj) {
      obj;
      /*if (obj.type == "click-profil") {
        this.$router.push({ path: "/edit-profil" });
      }*/
    }
  },
  mounted() {
    this.user = this.$store.state.userData;
    this.admin_level = this.user.admin_level;
    this.admin_levels = this.$store.state.admin_levels;
    this.circle = this.$store.state.circleData;
  }
};
</script>
